































































































































































































































































import axios from 'axios';
import Vue from 'vue';
import Detail from './Detail.vue';

export interface WithPk {
  pk: number,
}

export default Vue.extend({
  name: 'SearchForm',

  components: {
    Detail,
  },

  data: () => ({
    mounted: false,
    formValid: true,
    valid: {
      checked: false,
      indeterminate: true,
    },
    searchText: '',
    regulations: [],
    regulationLoading: false,
    regulationData: null,
    regulatedLevels: [],
    regulatedLevelsLoading: false,
    regulatedLevelsData: null,
    foods: {
      selected: [],
      data: [],
      loading: false,
      search: null,
      page: 1,
    },
    facets: {
      selected: [],
      data: [],
      loading: false,
      search: null,
      page: 1,
    },
    contaminants: {
      selected: [],
      data: [],
      loading: false,
      search: null,
      page: 1,
    },
    taxonomySearchModifiers: [
      { name: 'Exact FoodEx2 codes', suffix: '_exact', hint: 'Only records with exactly matched FoodEx2 codes' },
      { name: 'Include FoodEx2 parent codes', suffix: '_ancestors', hint: 'Include records for all FoodEx2 parent codes' },
      { name: 'Include FoodEx2 children codes', suffix: '_tree', hint: 'Include records for all FoodEx2 children codes' },
      { name: 'Include FoodEx2 parent/children codes', suffix: '_any', hint: 'Include records for all FoodEx2 parent/children codes' },
    ],
    foodSearchModifier: { name: 'Include FoodEx2 children codes', suffix: '_tree', hint: 'Include records for all FoodEx2 children codes' },
    validSearchModifiers: [
      { name: 'All', value: null, hint: 'All records' },
      { name: 'Valid', value: true, hint: 'Valid records only' },
      { name: 'Expired', value: false, hint: 'Expired records only' },
    ],
    validSearchModifier: { name: 'Valid', value: true, hint: 'Valid records only' },
    resultsLoading: false,
    resultsData: null,
    resultsSelected: [],
    resultsOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: [
      {
        text: '',
        value: 'valid',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Last modified',
        align: 'start',
        sortable: true,
        value: 'edited_at',
        width: '10%',
      },
      {
        text: 'Regulation',
        align: 'start',
        sortable: true,
        value: 'regulation_label',
      },
      {
        text: 'Analytical method reference',
        align: 'start',
        sortable: true,
        value: 'anlymethods',
      },
      {
        text: 'FoodEx2 food codes',
        align: 'start',
        value: 'foods',
        sortable: true,
        width: '20%',
      },
      {
        text: 'Contaminants',
        value: 'contaminants',
        align: 'start',
        sortable: true,
        width: '20%',
      },
      {
        text: 'Regulated levels',
        value: 'regulated_levels',
        align: 'start',
        sortable: true,
      },
    ],
    detail: null,
    showDetail: false,
  }),

  methods: {
    resultItemClass() {
      return ['clickable'];
    },
    setDetail(detail: any) {
      this.showDetail = !!(detail);
      this.detail = detail;
    },
    nextValid() {
      if (this.valid.indeterminate && this.valid.checked) {
        this.valid.indeterminate = false;
        this.valid.checked = true;
      } else if (!this.valid.indeterminate && this.valid.checked) {
        this.valid.indeterminate = true;
        this.valid.checked = false;
      } else if (!this.valid.indeterminate && !this.valid.checked) {
        this.valid.indeterminate = false;
        this.valid.checked = true;
      }
    },
    async getTaxonomies(name: string, root: any, url: string) {
      try {
        const query = [];
        if (root.search) {
          query.push(`search=${root.search}`);
        }
        query.push(`page=${root.page}`);
        root.loading = true;
        const resp = await axios.get(url + (query ? `?${query.join('&')}` : ''));
        if (root.data) {
          // @ts-ignore
          root.data.push(...resp.data.results);
        } else {
          root.data = resp.data.results;
        }
        root.page += 1;
      } catch (error) {
        window.console.log(`Error getting ${name} from the server: ${error}`);
      } finally {
        root.loading = false;
      }
    },
    async getFoods() {
      return this.getTaxonomies('foods', this.foods, this.foodsUrl);
    },
    async getFacets() {
      return this.getTaxonomies('facets', this.facets, this.facetsUrl);
    },
    async getContaminants() {
      return this.getTaxonomies('contaminants', this.contaminants, this.contaminantsUrl);
    },
    async getRegulations() {
      try {
        this.regulationLoading = true;
        const resp = await axios.get(this.regulationsUrl);
        this.regulationData = resp.data;
      } catch (error) {
        window.console.log(`Error getting regulations from the server: ${error}`);
      } finally {
        this.regulationLoading = false;
      }
    },
    async getRegulatedLevels() {
      try {
        this.regulatedLevelsLoading = true;
        const resp = await axios.get(this.regulatedLevelsUrl);
        this.regulatedLevelsData = resp.data;
      } catch (error) {
        window.console.log(`Error getting regulated levels from the server: ${error}`);
      } finally {
        this.regulatedLevelsLoading = false;
      }
    },
    async getResults() {
      try {
        this.resultsLoading = true;
        const resp = await axios.get(this.ruleUrl);
        this.resultsData = resp.data;
      } catch (error) {
        window.console.log(`Error getting results from the server: ${error}`);
      } finally {
        this.resultsLoading = false;
      }
    },
    async updateFoodSearch(food: any) {
      // @ts-ignore
      this.foods.selected = [food];
      this.setDetail(null);
      this.searchFoods();
      this.resultsOptions.page = 1;
      this.getResults();
    },
    searchFoods() {
      this.foods.page = 1;
      this.foods.data = [...this.foods.selected];
      this.getFoods();
    },
    async updateContaminantSearch(contaminant: any) {
      // @ts-ignore
      this.contaminants.selected = [contaminant];
      this.setDetail(null);
      this.searchContaminants();
      this.resultsOptions.page = 1;
      this.getResults();
    },
    searchContaminants() {
      this.contaminants.page = 1;
      this.contaminants.data = [...this.contaminants.selected];
      this.getContaminants();
    },
    async downloadCsv() {
      // This is a way how to force file download dialog
      // to be triggered from javascript.
      // it is a bit of a hack...

      const ids = this.resultsSelected.map((e: WithPk) => e.pk);
      try {
        const resp = await axios.request({
          url: this.csvUrl,
          method: 'POST',
          data: { ids },
          responseType: 'blob',
        });
        const downloadUrl = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'focov-records.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        window.console.log('Error getting csv from the server');
      }
    },
    formatDateTime(value: string) {
      const parsed = new Date(value);
      const year = parsed.getFullYear();
      const month = String(parsed.getMonth() + 1).padStart(2, '0');
      const day = String(parsed.getDate()).padStart(2, '0');
      const hours = String(parsed.getHours()).padStart(2, '0');
      const minutes = String(parsed.getMinutes()).padStart(2, '0');
      const seconds = String(parsed.getSeconds()).padStart(2, '0');
      return `<small><strong>${year}-${month}-${day}</strong> ${hours}:${minutes}:${seconds}</small>`;
    },
  },

  computed: {
    regulationItems(): any {
      return ((this.regulationData || { results: [] }).results || []);
    },
    regulatedLevelsItems(): any {
      return ((this.regulatedLevelsData || { results: [] }).results || []);
    },
    baseBackendUrl(): string {
      return this.$store.state.baseBackendUrl;
    },
    foodsUrl(): string {
      return `${this.baseBackendUrl}api/v1/foods/`;
    },
    facetsUrl(): string {
      return `${this.baseBackendUrl}api/v1/facets/`;
    },
    contaminantsUrl(): string {
      return `${this.baseBackendUrl}api/v1/contaminants/`;
    },
    regulationsUrl(): string {
      return `${this.baseBackendUrl}api/v1/regulations/`;
    },
    regulatedLevelsUrl(): string {
      return `${this.baseBackendUrl}api/v1/magnitudes/`;
    },
    filteringQueryPart(): Array<string> {
      const query = [];

      if (this.searchText) {
        // @ts-ignore
        query.push(`search=${this.searchText}`);
      }

      // valid filtering
      if (this.validSearchModifier.value != null) {
        query.push(`valid=${this.validSearchModifier.value ? 'true' : 'false'}`);
      }

      this.regulations.forEach((regulation: WithPk) => query.push(`regulations=${regulation.pk}`));
      this.regulatedLevels.forEach((regulatedLevel: WithPk) => query.push(`regulated_levels=${regulatedLevel.pk}`));
      this.foods.selected.forEach((food: WithPk) => query.push(`foods${this.foodSearchModifier.suffix}=${food.pk}`));
      this.facets.selected.forEach((facet: WithPk) => query.push(`facets=${facet.pk}`));
      this.contaminants.selected.forEach((contaminant: WithPk) => query.push(`contaminants=${contaminant.pk}`));

      return query;
    },
    resultsQuery(): string {
      const query = [];

      // Filter pagination
      if (this.resultsOptions.itemsPerPage) {
        query.push(`page_size=${this.resultsOptions.itemsPerPage}`);
      }
      // @ts-ignore
      if (this.resultsOptions.page) {
        // @ts-ignore
        query.push(`page=${this.resultsOptions.page}`);
      }

      // Filter ordering
      const ordering = [];
      // @ts-ignore
      for (let i = 0; i < this.resultsOptions.sortBy.length; i += 1) {
        // @ts-ignore
        const desc = this.resultsOptions.sortDesc[i] ? '-' : '';
        // @ts-ignore
        switch (this.resultsOptions.sortBy[i]) {
          case 'paragraph_label':
            ordering.push(`${desc}paragraph`);
            break;
          case 'section_label':
            ordering.push(`${desc}section`);
            break;
          case 'regulation_label':
            ordering.push(`${desc}regulation`);
            break;
          case 'foods':
            ordering.push(`${desc}foods_name`);
            break;
          case 'contaminants':
            ordering.push(`${desc}contaminants_name`);
            break;
          case 'anlymethods':
            ordering.push(`${desc}anlymethods_name`);
            break;
          case 'regulated_levels':
            ordering.push(`${desc}magnitudes_name`);
            break;
          case 'edited_at':
            ordering.push(`${desc}edited_at`);
            break;
          default:
        }
      }
      if (ordering.length > 0) {
        query.push(`ordering=${ordering.join(',')}`);
      } else {
        query.push('ordering=-edited_at');
      }

      const finalQuery = [...query, ...this.filteringQueryPart];
      return finalQuery.length > 0 ? `?${finalQuery.join('&')}` : '';
    },
    csvQuery(): string {
      return this.filteringQueryPart.length > 0 ? `?${this.filteringQueryPart.join('&')}` : '';
    },
    ruleUrl(): string {
      return `${this.baseBackendUrl}api/v1/rules/${this.resultsQuery}`;
    },
    csvUrl(): string {
      return `${this.baseBackendUrl}api/v1/rules/csv/${this.csvQuery}`;
    },
    resultsTotal(): number {
      if (!this.resultsData) {
        return 0;
      }
      return (this.resultsData || { count: 0 }).count || 0;
    },
    selectedResultsTotal(): number {
      return this.resultsSelected.length || this.resultsTotal;
    },
    resultsItems(): any {
      if (!this.resultsData) {
        return [];
      }
      return (this.resultsData || { results: [] }).results || [];
    },
  },
  watch: {
    resultsOptions: {
      handler() {
        this.getResults();
      },
      deep: true,
    },
    // eslint-disable-next-line
    'foods.search': function () {
      this.searchFoods();
    },
    // eslint-disable-next-line
    'facets.search': function () {
      this.facets.page = 1;
      this.facets.data = [...this.facets.selected];
      this.getFacets();
    },
    // eslint-disable-next-line
    'contaminants.search': function () {
      this.searchContaminants();
    },
    showDetail() {
      if (!this.showDetail) {
        this.detail = null;
      }
    },
    regulations() {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    regulatedLevels() {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    searchText() {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    validSearchModifier() {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    foodSearchModifier() {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    // eslint-disable-next-line
    'contaminants.selected': function () {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    // eslint-disable-next-line
    'foods.selected': function () {
      this.resultsOptions.page = 1;
      this.getResults();
    },
    // eslint-disable-next-line
    'facets.selected': function () {
      this.resultsOptions.page = 1;
      this.getResults();
    },
  },
  async mounted() {
    this.getFoods();
    this.getFacets();
    this.getContaminants();
    this.getRegulations();
    this.getRegulatedLevels();
    this.getResults();
    this.mounted = true;
  },
});
